import { computeRemSize } from '@ydistri/theme';
import { CalculationStatisticRouteResponse } from '@ydistri/api-sdk';
import { useMemo } from 'react';
import { useCurrency } from '../../../../../hooks/useCurrency';
import {
  EntityColumns,
  useStoreTableColumnsProvider,
} from '../../../../../hooks/useEntityTableColumnsProvider';
import { getStatisticsRouteTableColumns } from './statisticsModalTableColumns';
import { ColumnsType } from 'antd/es/table';

export const useTableRouteColumns = (
  displayDepartment = false,
): ColumnsType<CalculationStatisticRouteResponse> => {
  const currencyId = useCurrency();
  const storeColumnsProvider = useStoreTableColumnsProvider();

  return useMemo(() => {
    const columnConfig = {
      [EntityColumns.ID]: {
        width: computeRemSize(120),
      },
      [EntityColumns.CODE]: {
        width: computeRemSize(120),
      },
    };
    const sourceEntityColumns = storeColumnsProvider<CalculationStatisticRouteResponse>(
      columnConfig,
      'sourceStore',
      'Source Store',
    );

    const targetEntityColumns = storeColumnsProvider<CalculationStatisticRouteResponse>(
      columnConfig,
      'targetStore',
      'Target Store',
    );

    return getStatisticsRouteTableColumns(
      currencyId,
      displayDepartment,
      sourceEntityColumns,
      targetEntityColumns,
    );
  }, [currencyId, displayDepartment, storeColumnsProvider]);
};
